module.exports = __webpack_public_path__ + "static/fonts/proximasoft-webfont.9bbbe9c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoft-webfont.woff
// module id = 1027
// module chunks = 11